import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { PatchUserNotificationSettings } from '../../types/user.types';
import { useAppMutation } from '../use-app-mutation.hook';

export enum NotificationSettingsType {
  EMAIL = 'email',
  IN_APP = 'in-app',
}

export const useUpdateNotificationSettings = () => {
  const { mutate: update, isPending } = useAppMutation(
    [QueryKey.PATCH_USER_NOTIFICATION_SETTINGS],
    {
      mutationFn: ({
        data,
        type,
      }: {
        data: PatchUserNotificationSettings;
        type: NotificationSettingsType;
      }) =>
        ApiService.patch(
          {
            endpoint: BackendRoute.USERS,
            routePath: [
              'notification-settings',
              type === NotificationSettingsType.EMAIL ? 'email' : 'in-app',
            ],
          },
          { body: data },
        ),
    },
  );
  return { update, isPending };
};
